import React from 'react'
import PropTypes from 'prop-types'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import InnerList from './InnerList'

export default class SimpleSortable extends React.Component {
  static propTypes = {
    // Plain array or ImmutableJS list
    data: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.shape({
        map: PropTypes.func.isRequired,
      }),
    ]),
    renderDraggable: PropTypes.func.isRequired,
    useDragHandle: PropTypes.bool,
    getId: PropTypes.func,
  }

  static defaultProps = {
    getId: (obj) => obj.id || (obj.get && obj.get('id')),
    useDragHandle: true,
  }

  onDragEnd = (result) => {
    if (!result.destination) return

    this.props.onReorder({
      oldIndex: result.source.index,
      newIndex: result.destination.index,
    })
  }

  render() {
    const { data, renderDraggable, getId, useDragHandle, getDraggableProps } = this.props

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div ref={provided.innerRef}>
              <InnerList
                data={data}
                renderDraggable={renderDraggable}
                getId={getId}
                useDragHandle={useDragHandle}
                getDraggableProps={getDraggableProps}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}
